export let RecipientType;
(function (RecipientType) {
  RecipientType[RecipientType["CHANNEL"] = 0] = "CHANNEL";
  RecipientType[RecipientType["USER"] = 1] = "USER";
})(RecipientType || (RecipientType = {}));